import { useQuery } from "@tanstack/react-query";
import { ResponderApi } from "../../api/services";
import { EmptyState, PageHeader, Spinner, StatusBadge } from "../../components/common";
import { dateTime } from "../../lib/format";

export default function ResponderHistory() {
  const { data, isLoading } = useQuery({ queryKey: ["responder", "history"], queryFn: ResponderApi.history });
  if (isLoading) return <Spinner />;
  return (
    <div className="space-y-3">
      <PageHeader title="Trip history" />
      {!data?.length ? <EmptyState title="No completed trips yet" testId="responder-history-empty" /> : data.map((b) => (
        <div key={b.id} className="fp-card flex items-center justify-between gap-3" data-testid="responder-history-row">
          <div className="min-w-0">
            <p className="fp-label">{b.type} · {b.code}</p>
            <p className="truncate text-sm font-medium">{b.pickup.address || "Pinned pickup"}{b.destination ? ` → ${b.destination.address || "destination"}` : ""}</p>
            <p className="text-xs text-slate-500">{dateTime(b.completed_at || b.updated_at)}</p>
          </div>
          <StatusBadge status={b.status} />
        </div>
      ))}
    </div>
  );
}
